import Form from 'shared/migration-components/form';
import {Link, useNavigate} from 'react-router-dom';
import useFormInputs from 'shared/migration-components/form/util';
import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';

import {Card, Container, LinkText, Login, Content} from './styles';
import useCitiesSelect from 'modules/cities/hooks/use-cities-select';
import {CompanyProps, DeliveryModeEnum} from 'modules/companies/types';
import useCreateCompany from 'modules/companies/hooks/use-create-company';
import {useState} from 'react';
import useSegmentsByCitySelect from 'modules/segments/hooks/use-segments-by-city-select';
import {SponsorTypeEnum} from 'modules/coupons/types';

const CreateCompany: React.FC = () => {
  const {
    getInput,
    getNumberInput,
    getMultiSelect,
    getSelect,
    getAddressInput,
    getImagePicker,
  } = useFormInputs<CompanyProps>();

  const {data, isLoading} = useCitiesSelect();
  const [cityId, setCityId] = useState<string>();
  const segmentsSelect = useSegmentsByCitySelect(cityId);
  const navigate = useNavigate();
  const theme = localStorage.getItem('theme');

  const handleSubmit = (data: CompanyProps) => {
    const formData = new FormData();

    formData.append('name', data.name);
    formData.append('email', data.email);
    formData.append('cnpj', data.cnpj);
    formData.append('phone', data.phone);
    formData.append('cityId', data.cityId);
    formData.append(
      'excludedPaymentMethodsIds',
      JSON.stringify(data.excludedPaymentMethodsIds),
    );
    formData.append('freeDeliverySponsor', data.freeDeliverySponsor);
    formData.append('segmentsIds', JSON.stringify(data.segmentsIds));
    formData.append('address', JSON.stringify(data.address));
    formData.append('deliveryMode', data.deliveryMode);
    if (data.deliveryPrice)
      formData.append('deliveryPrice', String(data.deliveryPrice));
    formData.append('deliveryTime', String(data.deliveryTime));
    formData.append('deliveryByCompany', String(data.deliveryByCompany));
    if (data.logo) formData.append('logo', data.logo);
    if (data.banner) formData.append('banner', data.banner);
    formData.append('isOrganic', 'true');

    return formData;
  };

  return (
    <Container>
      <Content>
        <Card>
          <img
            src={theme === 'dark' ? darkLogo : logo}
            style={{
              width: 180,
              height: 120,
              alignSelf: 'center',
              marginLeft: -20,
            }}
          />
          <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
            <Form
              defaultValues={{
                deliveryMode: DeliveryModeEnum.neighborhood,
                freeDeliverySponsor: SponsorTypeEnum.CITY,
              }}
              {...{
                handleSubmit,
                onFormStateChange: (data) => {
                  if (data.cityId && data.cityId !== cityId)
                    setCityId(data.cityId);
                },
              }}
              inputs={[
                getInput({
                  name: 'name',
                  placeholder: 'Nome da empresa',
                }),
                getInput({name: 'email'}),
                getInput({name: 'cnpj', gridColumn: 4}),
                getInput({name: 'phone', gridColumn: 4}),
                getSelect({name: 'cityId', data, isLoading, gridColumn: 4}),
                getMultiSelect({
                  name: 'segmentsIds',
                  data: segmentsSelect.data,
                }),
                getAddressInput({label: 'Endereço', name: 'address'}),
                getNumberInput({
                  name: 'deliveryTime',
                }),
                getImagePicker({label: 'Logo', name: 'logo'}),
                getImagePicker({label: 'Banner', name: 'banner'}),
              ]}
              translationKey="CompanyProps"
              onSubmit={useCreateCompany}
              buttonProps={{
                title: 'Criar empresa',
                widthMode: 'expand',
              }}
            />
          </div>
        </Card>
        <Login onClick={() => navigate('/access-controls')}>
          Alterar acesso?
          <Link to="/access-controls">
            <LinkText> Voltar</LinkText>
          </Link>
        </Login>
      </Content>
    </Container>
  );
};

export default CreateCompany;
